import React, { useEffect, useState } from "react";
import { View, Image, StyleSheet } from "react-native";
import Video from "react-native-video";
import { useIsFocused } from "@react-navigation/native";
import Loader from "react-native-spinkit";
import color from "@constants/color";

const LoadingView = () => {
  return (
    <View
      style={{
        backgroundColor: "white",
        marginLeft: 6,
        paddingHorizontal: 12,
        paddingVertical: 6,
        paddingRight: 52,
        borderRadius: 6,
        elevation: 1,
      }}
    >
      <Loader
        isVisible={true}
        size={28}
        type="ThreeBounce"
        color={color.primary}
      />
    </View>
  );
};

const MessageWrapper = ({
  children,
  index,
  wrap,
  styles = {},
  item = {},
  onVideoEnd = () => {},
  onVideoStart = () => {},
  messageLoading,
  isMute,
}) => {
  const [playing, setPlaying] = useState(true);
  const isFocused = useIsFocused();
  const [calledEnd, setCalledEnd] = useState(false);

  useEffect(() => {
    if (!isFocused) {
      setPlaying(false);
    }
  }, [isFocused]);

  const handleOnLoad = () => onVideoStart(true);
  const handleOnEnd = () => {
    // on end was calling twice so this condition was required
    if (!calledEnd) {
      setPlaying(false);
      onVideoEnd(item.cms_item_id, true);
      setCalledEnd(true);
    }
  };

  return (
    <View style={[stylesRn.container, styles]}>
      <View>
        <Image
          source={require("../../../assets/svg/Jrny/cl-chat.png")}
          resizeMode="contain"
          style={{ height: 32, width: 32 }}
        />
      </View>
      {messageLoading ? (
        <LoadingView />
      ) : (
        <View style={{ flex: wrap ? 0 : 1 }}>{children}</View>
      )}
      {item.audio_link && !item.is_viewed && (
        <Video
          paused={!playing}
          muted={isMute}
          audioOnly
          repeat={false}
          onLoad={handleOnLoad}
          onEnd={handleOnEnd}
          resizeMode="cover"
          source={{
            uri: item.audio_link,
          }}
        />
      )}
    </View>
  );
};

export default MessageWrapper;

const stylesRn = StyleSheet.create({
  container: {
    flexDirection: "row",
    marginTop: 16,
    marginHorizontal: 8,
  },
});
